import React from "react";
import { connect } from "react-redux";
function Navbar(props) {
  const {addedItems} = props;
  return (
    <nav className="navbar sticky-top  navbar-expand-lg navbar-danger bg-danger">
      <svg
        className="bi bi-handbag-fill text-light m-1"
        width="2.5em"
        height="2.5em"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 1a2 2 0 0 0-2 2v2H5V3a3 3 0 1 1 6 0v2h-1V3a2 2 0 0 0-2-2z" />
        <path d="M3.405 5a1.5 1.5 0 0 0-1.493 1.35L1 13.252A2.5 2.5 0 0 0 3.488 16h9.024A2.5 2.5 0 0 0 15 13.251l-.912-6.9A1.5 1.5 0 0 0 12.595 5H11v2.5a.5.5 0 1 1-1 0V5H6v2.5a.5.5 0 0 1-1 0V5H3.405z" />
      </svg>
      <a href="/" className="navbar-brand text-light m-1 align-self-center">
        {/* <img src="https://freesvg.org/img/Paper-shopping-bag-Woofer.png" width="50" 
          height="50"/> */}
        Shopping
      </a>
      <ul className="navbar-nav ml-auto">
        <div className="navbar-item ">
          <button
            type="button"
            className="btn text-light "
            data-toggle="modal"
            data-target="#exampleModal"
          >
            <svg
              className="bi bi-cart4"
              width="2em"
              height="2em"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l.5 2H5V5H3.14zM6 5v2h2V5H6zm3 0v2h2V5H9zm3 0v2h1.36l.5-2H12zm1.11 3H12v2h.61l.5-2zM11 8H9v2h2V8zM8 8H6v2h2V8zM5 8H3.89l.5 2H5V8zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
              />
              
            </svg><span class="badge badge-light m-1">{addedItems}</span>
          </button>
        </div>
      </ul>
    </nav>
  );
}
const mapStateToProps = (state) => {
  const { addedItems } = state;
  return { addedItems };
};

export default connect(mapStateToProps)(Navbar);
